"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TherapyNoteScreen = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const TherapyNoteScreen = ({ pendingTherapyNote, pendingUserSession, pendingTherapyNoteCreate, pendingTherapyNoteUpdate, pendingDeleteTherapyNote, userSession, match, therapyNote, user, getTherapyNote, getUserSession, deleteTherapyNote, }) => {
    var _a;
    const { therapyNoteId, accountId, sessionId } = match.params;
    react_1.useEffect(() => {
        getTherapyNote({ id: therapyNoteId });
        getUserSession({ id: sessionId });
    }, [user]);
    if (pendingTherapyNote || pendingUserSession)
        return react_1.default.createElement(components_1.ScreenLoader, null);
    return (react_1.default.createElement("div", { className: styles_scss_1.default.therapyNote },
        pendingTherapyNoteCreate || pendingTherapyNoteUpdate && (react_1.default.createElement(components_1.SaveLoader, { title: constants_1.default.patientProgress.therapyNote.savingNote, description: constants_1.default.general.pleaseDontClose })),
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.patientProgress.therapyNote.helmetTitle, removeViewport: true }),
        react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.contentPaper },
            react_1.default.createElement(components_1.Link, { to: constants_1.Routes.PatientProgressDetail.replace(':accountId', accountId) },
                react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.goBackButton, variant: "transparent", title: constants_1.default.patientProgress.therapyNote.backToPatientProgress, ariaLabel: constants_1.default.patientProgress.therapyNote.backToPatientProgress, imgUrls: { default: constants_1.Images.arrowLeftGreen, selected: constants_1.Images.arrowLeftGreen } })),
            react_1.default.createElement("div", { className: styles_scss_1.default.headerCont },
                react_1.default.createElement("div", { className: styles_scss_1.default.headerLeftCont },
                    react_1.default.createElement("h2", null, constants_1.default.patientProgress.therapyNote.pageTitle((_a = userSession === null || userSession === void 0 ? void 0 : userSession.session) === null || _a === void 0 ? void 0 : _a.session_type)))),
            react_1.default.createElement("div", { className: styles_scss_1.default.formCont },
                react_1.default.createElement(forms_1.TherapyNoteForm, { therapyNote: therapyNote, therapyNoteId: therapyNoteId, sessionId: sessionId, accountId: accountId, deleteTherapyNote: deleteTherapyNote, pendingTherapyNoteDelete: pendingDeleteTherapyNote })))));
};
exports.TherapyNoteScreen = TherapyNoteScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    therapyNote: selectors_1.default.therapy.getTherapyNote(state),
    pendingTherapyNote: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.getTherapyNote),
    pendingUserSession: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.getUserSession),
    userSession: selectors_1.default.program.getUserSession(state),
    pendingTherapyNoteUpdate: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.updateTherapyNote),
    pendingTherapyNoteCreate: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.createTherapyNote),
    pendingDeleteTherapyNote: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.deleteTherapyNote),
});
const mapDispatchToProps = {
    getTherapyNote: (data) => radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.getTherapyNotePayload(data)),
    getUserSession: (data) => radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.getUserSessionPayload(data)),
    deleteTherapyNote: (data) => radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.deleteTherapyNotePayload(data)),
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.TherapyNoteScreen));
